/* Policy pages: reading time, "On this page" contents with scroll-spy, and native policy title */
(() => {
  const init = () => {
    const root = document.querySelector('[data-policy]');
    if (!root || root.dataset.ready) return;
    root.dataset.ready = 'true';
    const wrap = root.querySelector('[data-policy-body]');
    if (!wrap) return;
    const body = wrap.querySelector('.shopify-policy__body') || wrap;

    // Native policy pages: lift Shopify's title into our hero
    const nativeTitle = wrap.querySelector('.shopify-policy__title');
    const head = root.querySelector('[data-policy-native-head]');
    if (nativeTitle && head) {
      const h1 = document.createElement('h1');
      h1.className = 'skin-policy__title';
      h1.textContent = nativeTitle.textContent.trim();
      head.insertBefore(h1, head.querySelector('.skin-policy__meta'));
      nativeTitle.remove();
      document.title = document.title || h1.textContent;
    }

    // Wide tables: wrap so they scroll inside the body on small screens
    body.querySelectorAll('table').forEach((table) => {
      if (table.parentElement.classList.contains('skin-policy__table')) return;
      const scroller = document.createElement('div');
      scroller.className = 'skin-policy__table';
      scroller.tabIndex = 0;
      scroller.setAttribute('role', 'region');
      scroller.setAttribute('aria-label', 'Table');
      table.replaceWith(scroller);
      scroller.appendChild(table);
    });

    // Switcher: bring the current policy into view when the pills overflow (mobile)
    const navList = root.querySelector('.skin-policy__nav ul');
    const current = navList && navList.querySelector('[aria-current="page"]');
    if (current && navList.scrollWidth > navList.clientWidth) {
      const li = current.closest('li');
      navList.scrollLeft = Math.max(0, li.offsetLeft - navList.offsetLeft - (navList.clientWidth - li.offsetWidth) / 2);
    }

    // Reading time
    const words = (body.textContent || '').trim().split(/\s+/).filter(Boolean).length;
    const read = root.querySelector('[data-policy-read]');
    if (read && words > 80) {
      read.textContent = `${Math.max(1, Math.round(words / 200))} min read`;
      read.hidden = false;
    }

    // Policies written with bold lines instead of headings: treat short bold-only paragraphs as headings
    let headings = Array.from(body.querySelectorAll('h2, h3'));
    if (headings.length < 2) {
      Array.from(body.querySelectorAll('p')).forEach((p) => {
        const strong = p.querySelector('strong, b');
        const text = p.textContent.trim();
        if (strong && strong.textContent.trim() === text && text.length > 2 && text.length < 90) {
          const h = document.createElement('h2');
          h.textContent = text.replace(/:$/, '');
          p.replaceWith(h);
        }
      });
      headings = Array.from(body.querySelectorAll('h2, h3'));
    }

    const toc = root.querySelector('[data-policy-toc]');
    const list = root.querySelector('[data-policy-toc-list]');
    if (!toc || !list || headings.length < 2) {
      root.classList.add('skin-policy--no-toc');
      return;
    }

    const used = {};
    const slug = (t) => {
      let base = t.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '').slice(0, 60) || 'section';
      const n = (used[base] = (used[base] || 0) + 1);
      return n > 1 ? `${base}-${n}` : base;
    };
    headings.forEach((h) => {
      if (!h.id) h.id = slug(h.textContent);
      const li = document.createElement('li');
      li.className = h.tagName === 'H3' ? 'is-sub' : '';
      const a = document.createElement('a');
      a.href = `#${h.id}`;
      a.textContent = h.textContent.trim();
      li.appendChild(a);
      list.appendChild(li);
    });
    toc.hidden = false;

    const details = toc.querySelector('details');
    const mobile = window.matchMedia('(max-width: 989px)');
    const syncOpen = () => {
      if (details) details.open = !mobile.matches;
    };
    syncOpen();
    mobile.addEventListener('change', syncOpen);
    list.addEventListener('click', (e) => {
      if (e.target.closest('a') && mobile.matches && details) details.open = false;
    });

    // Scroll-spy
    const links = Array.from(list.querySelectorAll('a'));
    const setActive = (id) => links.forEach((a) => a.classList.toggle('is-active', a.getAttribute('href') === `#${id}`));
    const observer = new IntersectionObserver(
      (entries) => {
        const visible = entries.filter((e) => e.isIntersecting).sort((a, b) => a.boundingClientRect.top - b.boundingClientRect.top);
        if (visible[0]) setActive(visible[0].target.id);
      },
      { rootMargin: '-20% 0px -70% 0px' }
    );
    headings.forEach((h) => observer.observe(h));
    setActive(headings[0].id);
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
